module.exports = __webpack_public_path__ + "img/shen.29cf3570.png";